module.exports = __webpack_public_path__ + "static/media/Luminita.72deac02.jpg";